import React, { FC, useEffect, useState } from "react";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { Clickable, Hidden, Typography } from "@insite/mobius/index";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ADIColors from "@NA/Utils/ADIColors";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import { ResolveThunks, connect, useDispatch, useSelector } from "react-redux";
import { css } from "styled-components";
import Icon from "@insite/mobius/Icon";
import Button, { ButtonWrapper } from "@insite/mobius/Button";
import styled from "styled-components";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { CreditCardListInvoiceRecap } from "@NA/Components/MyAccountRecapPayment/ADICreditCardListInvoiceRecap";
import { BankAccountListInvoiceRecap } from "@NA/Components/MyAccountRecapPayment/ADIBankAcountListInvoiceRecap";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import adiGetBankAccountList from "@NA/Handlers/Invoices/ADIGetBankAccountList";
import adiPayInvoiceHandler from "@NA/Handlers/Invoices/ADIPayInvoiceHandler";
import adiSendInvoicePaymentEmail from "@NA/Handlers/Invoices/ADISendInvoicePaymentEmail";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import { BankAccount } from "@NA/Services/ADIInvoiceService";
import ValidationSuccessIcon from "@NA/Icons/ValidationSuccessIcon";
import PaymentWarningIcon from "@NA/Icons/PaymentWarningIcon";
import PrintIcon from "@NA/Icons/PrintIcon";
import openPrintDialog from "@insite/client-framework/Common/Utilities/openPrintDialog";
import adiGetCreditCardListRecap from "@NA/Handlers/Invoices/ADIGetCreditCardListRecap";
import { cloneDeep } from "lodash";
import loadADIInvoices from "@NA/Handlers/InvoiceHistory/ADIInvoiceHistoryHandler";
import { getStatuscall } from "@NA/Services/ADIgetStatusCall";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import { StyledButton } from "@insite/mobius/Clickable";

const mapStateToProps = (state: CustomApplicationState) => {
    const session = state.context.session;
    const adminDCEmail = session.properties.adminDCEmail;
    const cart = getCurrentCartState(state).value;
    const isAuthenticated = session && session.isAuthenticated;
    const { cartId } = state.pages.checkoutReviewAndSubmit;
    const cartState = cartId ? getCartState(state, cartId) : getCurrentCartState(state);
    const { search, pathname } = getLocation(state);
    const curentUserEmail = state.context.session.email;
    const invoicesLink = getPageLinkByPageType(state, "InvoiceHistoryPage")?.url;

    return {
        cartState,
        adminDCEmail,
        session,
        cart,
        isAuthenticated,
        search,
        pathname,
        overallBankAccountList: state.ADIGlobalData.adiBankAccountListStore.bankAccountDetails,
        bankAccountList: state.ADIGlobalData.adiBankAccountListStore.bankAccountDetails?.bankPaymentInfomration,
        isLoading: state.ADIGlobalData.adiBankAccountListStore.isLoading,
        invoicePaymentRecapData: state.ADIGlobalData.adiInvoicePaymentRecap.InvoicePaymentRecap,
        creditCardListRecap: state.ADIGlobalData.adiCreditCardListRecapStore.creditCardDetails?.creditCardDtoCollection,
        isLoadingCreditCard: state.ADIGlobalData.adiCreditCardListRecapStore.isLoading,
        curentUserEmail,
        getADIInvoiceParameter: state.ADIGlobalData.ADIInvoiceStore.loadInvoiceParameters,
        invoicesLink,
        creditCardPaymentTypes: state.ADIGlobalData.adiCreditCardListRecapStore.creditCardDetails,
    };
};

const mapDispatchToProps = {
    adiGetBankAccountList,
    adiPayInvoiceHandler,
    adiSendInvoicePaymentEmail,
    adiGetCreditCardListRecap,
    loadADIInvoices,
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

export interface InvoiceHeaderTabsStyles {
    container?: InjectableCss;
    tabs?: InjectableCss;
    noDataFound?: InjectableCss;
    addNewTitle?: InjectableCss;
    tableHeaderWrapper?: InjectableCss;
    button?: InjectableCss;
    footerButtonWrapper?: InjectableCss;
    cancelButton?: InjectableCss;
    errorMsgWrapper?: InjectableCss;
    successMsgWrapper?: InjectableCss;
    printButton?: InjectableCss;
}

export const tableStyles: InvoiceHeaderTabsStyles = {
    container: {
        css: css`
            display: flex;
            padding: 2px;
            border-radius: 6px;
            border: solid 1px ${ADIColors.gray2};
            background: ${ADIColors.white};
            max-width: 400px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        max-width: 100%;
                        flex-basis: 100%;
                `,
                    css`
                        max-width: 100%;
                        flex-basis: 100%;
                `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    tabs: {
        css: css`
            padding: 7px 30px;
            border-radius: 6px;
            border: 0;
            background-color: #fff;
            text-align: center;
            font-size: ${getProp("theme.typography.headerTertiary.size")};
            line-height: 22px;
            font-weight: normal;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            transition: all 0.1s ease;
            position: relative;
            overflow: visible;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                padding: 7px 10px;
                width: 50%;
                `,
                    css`
                padding: 7px 10px;
                width: 50%;
                `,
                    null,
                    null,
                    null,
                ])}
            &:nth-of-type(2) {
                margin-left: 10px;
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                width: 50%;
                `,
                    css`
                width: 50%;
                `,
                    null,
                    null,
                    null,
                ])}
            }

            &::after {
                content: "";
                width: 3px;
                height: 22px;
                margin: 6px 0 6px 1px;
                border-radius: 1px;
                background-color: ${ADIColors.gray2};
                position: absolute;
                right: -6px;
                z-index: 10;
            }

            &:last-child::after {
                display: none;
            }

            &.active {
                background-color: ${ADIColors.darkBlue1};
                color: ${ADIColors.white};
                font-weight: 600;                
            }
        `,
    },
    noDataFound: {
        css: css`
            margin-top: 36px;
            margin-bottom: 20px;
            font-size: 20px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.3;
            letter-spacing: normal;
            text-align: center;
            color: #666;
            display: block;
        `,
    },
    addNewTitle: {
        css: css`
            font-weight: 700;
            color: ${ADIColors.blue5};
        `,
    },
    tableHeaderWrapper: {
        css: css`
            background-color: ${ADIColors.gray6};
            border: none;
        `,
    },
    footerButtonWrapper: {
        css: css`
            display: flex;
            gap: 15px;
            justify-content: right;
            margin-top: 15px;
            > ${StyledButton}{
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                width: 50%;
                `,
                    css`
                width: 50%;
                `,
                    null,
                    null,
                    null,
                ])}
            }
            > ${ButtonWrapper} {
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                width: 50%;
                `,
                    css`
                width: 50%;
                `,
                    null,
                    null,
                    null,
                ])}
            &:disabled{
                background-color: #006ae3 !important;
                opacity: .4;
                border: none;
            }
            }
            
        `,
    },
    button: {
        css: css`
            width: 200px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                width: 50%;
                `,
                    css`
                width: 50%;
                `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    cancelButton: {
        css: css`
            width: 200px;
            > span {
                color: ${ADIColors.blue5};
            }
        `,
    },
    errorMsgWrapper: {
        css: css`
            width: 100%;
            font-weight: 700;
            display: flex;
            align-items: center;
            span {
                margin-right: 10px;
            }
        `,
    },
    successMsgWrapper: {
        css: css`
            width: 100%;
            font-weight: 700;
            display: flex;
            align-items: center;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                    `,
                    css`
                        flex-direction: column;
                    `,
                    css``,
                    css``,
                    null,
                ])}
            span {
                margin-right: 10px;
                font-size: 14px;
                font-weight: 800;
                &:first-child {
                    top: 7px;
                    position: relative;
                }
            }    
        `,
    },
    printButton: {
        css: css`
            margin-left: auto;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-left: inherit;
                        margin-top: 20px;
                        margin-bottom: 20px;
                    `,
                    css`
                        margin-left: inherit;
                        margin-top: 20px;
                        margin-bottom: 20px;
                    `,
                    css``,
                    css``,
                    null,
                ])}
                button {
                    width: auto;
                    span {
                        margin: 0;
                        &:first-child {
                            top: 0px;
                        }
                    }
                }
        `,
    },
};

const styles = tableStyles;

const AddButton = styled.div`
    cursor: pointer;
    padding: 2px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 5px 0 7px;
    gap: 15px;
    svg:hover {
        color: #9b9b9b;
    }
`;
const TabSectionWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
    background-color: ${ADIColors.white};
    flex-wrap: wrap;
    gap: 15px;
    ${({ theme }: { theme: BaseTheme }) =>
        breakpointMediaQueries(theme, [
            css`
                width: calc(100% + 30px);
                margin-left: -15px;
                `,
            css`
                width: calc(100% + 30px);
                margin-left: -15px;
                
                `,
            null,
            null,
            null,
        ])}
`;
const BankAccountWrapper = styled.div`
    @media only screen and (max-width: 710px) {
        width: calc(100% + 30px);
        margin: -10px 0 -10px -15px;
    }
`;

const ADIInvoiceRecapTab: React.FunctionComponent<Props> = ({
    cartState,
    adminDCEmail,
    session,
    cart,
    isAuthenticated,
    search,
    pathname,
    history,
    bankAccountList,
    isLoading,
    invoicePaymentRecapData,
    adiGetBankAccountList,
    adiPayInvoiceHandler,
    adiSendInvoicePaymentEmail,
    adiGetCreditCardListRecap,
    creditCardListRecap,
    isLoadingCreditCard,
    curentUserEmail,
    overallBankAccountList,
    loadADIInvoices,
    getADIInvoiceParameter,
    invoicesLink,
    creditCardPaymentTypes,
}) => {
    const [current, setCurrent] = React.useState(0);
    const [openAddNewCard, setOpenAddNewCard] = React.useState(false);
    const [openAddNewAccount, setOpenAddNewAccount] = React.useState(false);
    const [selectedBankId, setSelectedBankId] = React.useState("");
    const [selectedCCId, setSelectedCCId] = React.useState("");
    const [selectedPaymentAccount, setSelectedPaymentAccount] = React.useState<BankAccount>();
    const [showSuccessMessage, setShowSuccessMessage] = React.useState(false);
    const [showErrorMessage, setShowErrorMessage] = React.useState(false);
    const [isDuplicateInvoicePayment, setisDuplicateInvoicePayment] = React.useState(false);
    const [paymentConfirmationNumber, setPaymentConfirmationNumber] = React.useState("");
    const [isPaymentInProgress, setIsPaymentInProgress] = React.useState(false);
    const [invoiceTotal, setInvoiceTotal] = React.useState(0);
    const [allowCCPayment, setAllowCCPayment] = React.useState(true);
    const [showCustomerStatusBanner, setShowCustomerStatusBanner] = useState<boolean>();
    const [showAllowInvoicePayment, setShowAllowInvoicePayment] = useState<string>('');
    const [paymentTypes, setPaymentTypes] = useState<any>(creditCardPaymentTypes);
    const getCustomerCreditStatus = useSelector(
            (state: CustomApplicationState) => state.ADIGlobalData.PricingStatusStore,
        );

    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch({
            type: "Custom/UpdatePaymentRecap",
            result: false,
        });
    }, []);

    const callApi = () => {
        adiGetCreditCardListRecap({});
    };
    React.useEffect(() => {
        adiGetBankAccountList({});
        adiGetCreditCardListRecap({});
    }, []);

    useEffect(() => {
        if (!isAuthenticated) {
            history.push(`/MyAccount/SignIn?returnUrl=${pathname}${search}`);
        }
    }, [isAuthenticated]);

    React.useEffect(() => {
        if (invoicePaymentRecapData?.invoices?.length) {
            const total = invoicePaymentRecapData.invoices.reduce((acc, invoice) => (acc += invoice.otherCharges), 0);
            setInvoiceTotal(parseFloat(total.toFixed(2)));
            const allowCC = invoicePaymentRecapData.properties.allowCCPayment === "True" ? true : false;
            setAllowCCPayment(allowCC);
            getStatusCall();
        }
    }, [invoicePaymentRecapData?.invoices]);

    // Handle Change To Credit Card Expiry When Selected - ADINA-54109
    React.useEffect(() => {
        setPaymentTypes(creditCardPaymentTypes);
        if (selectedCCId !== "") {
            const selectedCreditCard = creditCardListRecap?.filter(item => item.cardToken === selectedCCId)[0];
            const expiryMonth = selectedCreditCard?.expiryMonth || "";
            const expiryYear = selectedCreditCard?.expiryYear || "";
            const creditCardExpirationDate = expiryMonth + expiryYear;
            selectedCreditCard &&
                setSelectedPaymentAccount({
                    ...selectedPaymentAccount,
                    creditCardExpirationDate: creditCardExpirationDate,
                });
        }
    }, [creditCardListRecap]);

    async function getStatusCall() {
        // await getStatuscall().then((response) => {
        //     const showCustomerStatusBannerLocal = (response as any)?.response?.showCustomerStatusBanner
        //     const alloWInvoicePayment = (response as any)?.response?.allowWebPayments
        //     setShowCustomerStatusBanner(showCustomerStatusBannerLocal);
        //     setShowAllowInvoicePayment(alloWInvoicePayment);
        //     localStorage.setItem("showCustomerStatusBanner", showCustomerStatusBannerLocal)
        // }).catch((err) => {
        //     return err;
        // })
        const showCustomerStatusBanner = getCustomerCreditStatus?.getcustomerStatus?.showCustomerStatusBanner;
        const alloWInvoicePayment = getCustomerCreditStatus?.getcustomerStatus?.allowWebPayments;
        setShowCustomerStatusBanner(showCustomerStatusBanner);
        setShowAllowInvoicePayment(alloWInvoicePayment);
        localStorage.setItem("showCustomerStatusBanner", showCustomerStatusBanner);
    }

    const updateTab = (num: number = 0) => {
        if (current === num) {
            return;
        }
        setCurrent(num);
        if (num === 0) {
        }
        if (num === 1) {
        }
        setOpenAddNewAccount(false);
    };
    const showAddNewCard = () => {
        setOpenAddNewCard(!openAddNewCard);
    };
    const showAddNewAccount = () => {
        setOpenAddNewAccount(!openAddNewAccount);
    };
    const handleRadioChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedBankId(e.currentTarget.value);
        const inputValue = e.currentTarget.value;
        const bankAccNumber = inputValue.split("-")[0];
        const routingNumber = inputValue.split("-")[1];
        const paymentType = "B";
        const bankPaymentType = overallBankAccountList?.bankPaymentType;
        const bankPeriodDetails = overallBankAccountList?.bankPeriodDetails;
        const selectedBankAccounts = bankAccountList?.filter(
            (item: BankAccount) => item.bankAccountNumber === bankAccNumber,
        );
        if (!selectedBankAccounts) {
            return;
        }
        if (selectedBankAccounts.length > 1) {
            const selectedBankAcc = selectedBankAccounts.filter(
                (acc: BankAccount) => acc.routineNumber === routingNumber,
            )[0];
            const selectedBankWithPaymentType = {
                ...selectedBankAcc,
                paymentType,
                bankPaymentType,
                bankPeriodDetails,
            };
            setSelectedPaymentAccount(selectedBankWithPaymentType);
        } else {
            const selectedBankAcc = selectedBankAccounts[0];
            const selectedBankWithPaymentType = {
                ...selectedBankAcc,
                paymentType,
                paymentTypeId: bankPaymentType !== undefined ? bankPaymentType[0]?.paymentTypeId.toString() : "",
                paymentMethodId: bankPaymentType !== undefined ? bankPaymentType[0]?.paymentMethodId : "",
                paymentTypeDesc: bankPaymentType !== undefined ? bankPaymentType[0]?.paymentTypeDesc : "",
                period: bankPeriodDetails !== undefined ? bankPeriodDetails[0]?.period : "",
                yearForPeriod: bankPeriodDetails !== undefined ? bankPeriodDetails[0]?.yearForPeriod : "",
            };
            setSelectedPaymentAccount(selectedBankWithPaymentType);
        }
    };

    const handleCardRadioChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedCCId(e.currentTarget.value);
        const selectedCreditCard = creditCardListRecap?.filter(item => item.cardToken === e.currentTarget.value)[0];
        const paymentType = "C";
        const expiryMonth = selectedCreditCard?.expiryMonth || "";
        const expiryYear = selectedCreditCard?.expiryYear || "";
        const creditCardExpirationDate = expiryMonth + expiryYear;
        const creditCardType = selectedCreditCard?.cardType;
        const id = selectedCreditCard?.id;
        const creditCardToken = selectedCreditCard?.cardToken;
        const creditCardNumber = selectedCreditCard?.cardNumber;
        const bankNumber = selectedCreditCard?.creditCardBankNumber;
        const paymentMethodId = selectedCreditCard?.paymentMethodId;
        const paymentTypeDesc = selectedCreditCard?.paymentTypeDesc;
        const paymentTypeId = selectedCreditCard?.paymentTypeId;
        const period = selectedCreditCard?.period;
        const yearForPeriod = selectedCreditCard?.yearForPeriod;
        const postalCode = selectedCreditCard?.postalCode;


        const selectedCCWithPaymentType = {
            paymentType,
            creditCardExpirationDate,
            creditCardType,
            id,
            creditCardToken,
            creditCardNumber,
            bankNumber,
            paymentMethodId,
            paymentTypeDesc,
            paymentTypeId,
            period,
            yearForPeriod,
            postalCode,
        };
        if (selectedCreditCard) {
            setSelectedPaymentAccount(selectedCCWithPaymentType);
        }
    };

    const payNowClickHandler = () => {
        if (selectedPaymentAccount && !isPaymentInProgress) {
            setIsPaymentInProgress(true);
            adiPayInvoiceHandler({
                accountType: selectedPaymentAccount.accountType,
                accountDescription: selectedPaymentAccount.accountDescription,
                routineNumber: selectedPaymentAccount.routineNumber,
                bankAccountNumber: selectedPaymentAccount.bankAccountNumber,
                termsAgreed: selectedPaymentAccount.termsAgreed,
                paymentType: selectedPaymentAccount.paymentType,
                creditCardNumber: selectedPaymentAccount.creditCardNumber,
                creditCardType: selectedPaymentAccount.creditCardType,
                creditCardExpirationDate: selectedPaymentAccount.creditCardExpirationDate,
                creditCardToken: selectedPaymentAccount.creditCardToken,
                properties: selectedPaymentAccount.properties,
                bankId: selectedPaymentAccount.bankId,
                bankNumber: selectedPaymentAccount.bankNumber,
                paymentTypeId: selectedPaymentAccount.paymentTypeId,
                paymentMethodId: selectedPaymentAccount.paymentMethodId,
                paymentTypeDesc: selectedPaymentAccount.paymentTypeDesc,
                period: selectedPaymentAccount.period,
                yearForPeriod: selectedPaymentAccount.yearForPeriod,
                postalCode: selectedPaymentAccount.postalCode,

                onSuccess: (result: any) => {
                    setIsPaymentInProgress(false);
                    sessionStorage.setItem("selectedInvoices", JSON.stringify([]));
                    dispatch({
                        type: "Custom/UpdatePaymentRecap",
                        result: true,
                    });
                    if (
                        result != null &&
                        result.returnCode == "00" &&
                        result.paymentConfirmationNumber != null &&
                        result.paymentConfirmationNumber != ""
                    ) {
                        setPaymentConfirmationNumber(result.paymentConfirmationNumber);
                        if (invoicePaymentRecapData) {
                            let properties = cloneDeep(invoicePaymentRecapData.properties);
                            properties["confirmationNumber"] = result.paymentConfirmationNumber;
                            properties["toEmail"] = curentUserEmail;

                            adiSendInvoicePaymentEmail({
                                invoices: invoicePaymentRecapData.invoices,
                                pagination: invoicePaymentRecapData.pagination,
                                showErpOrderNumber: invoicePaymentRecapData.showErpOrderNumber,
                                properties: properties,
                                uri: invoicePaymentRecapData.uri,
                                onSuccess: (result: any) => {
                                    if (result != null && result === true) {
                                        setShowSuccessMessage(true);
                                        loadADIInvoices(getADIInvoiceParameter);
                                    }
                                },
                            });
                        }
                    } else if (result.properties["isDuplicateInvoicePayment"]) {
                        setisDuplicateInvoicePayment(true);
                    }
                    else { setShowErrorMessage(true); }
                },
            });
        }
    };

    if (invoiceTotal < 0) return null;


    return (
        <>
            {showSuccessMessage ? (
                <StyledWrapper {...styles.successMsgWrapper}>
                    <StyledWrapper>
                        <Icon src={ValidationSuccessIcon}></Icon>
                        <span>
                            {translate(
                                "This payment is being processed and you will receive an email confirmation. Your payment confirmation number is:",
                            )}{" "}
                            {paymentConfirmationNumber}
                        </span>
                    </StyledWrapper>
                    <StyledWrapper {...styles.printButton}>
                        <Clickable onClick={openPrintDialog}>
                            <Button {...styles.button}>
                                <Typography>{translate("Print")}</Typography>
                            </Button>
                        </Clickable>
                    </StyledWrapper>
                </StyledWrapper>
            ) : showErrorMessage ? (
                <StyledWrapper {...styles.errorMsgWrapper}>
                    <Icon src={PaymentWarningIcon}></Icon>
                    <span>
                        {translate(
                            "Invoice payment is currently not available online. Please wait 5 minutes and try again. If the issue persists, please contact your ADI credit representative for more assistance.",
                        )}{" "}
                        {paymentConfirmationNumber}
                    </span>
                </StyledWrapper>
            ) : isDuplicateInvoicePayment ? (
                <StyledWrapper {...styles.errorMsgWrapper}>
                    <Icon src={PaymentWarningIcon}></Icon>
                    <span>
                        {translate(
                            "One or More Selected Invoices has Payment Pending. Please Return to Invoice List Page.",
                        )}{" "}
                    </span>
                </StyledWrapper>
            ) : (
                <>
                    <TabSectionWrapper>
                        <StyledWrapper {...styles.container}>
                            <StyledWrapper
                                {...styles.tabs}
                                className={current === 0 ? "active" : "normal"}
                                onClick={() => updateTab(0)}
                            >
                                {translate("Pay via Bank Account")}
                            </StyledWrapper>
                            {allowCCPayment && (
                                <StyledWrapper
                                    {...styles.tabs}
                                    className={current === 1 ? "active" : "normal"}
                                    onClick={() => updateTab(1)}
                                >
                                    {translate("Pay via Credit Card")}
                                </StyledWrapper>
                            )}
                        </StyledWrapper>
                        <Hidden below="sm">
                            <AddButton onClick={() => (current === 0 ? showAddNewAccount() : showAddNewCard())}>
                                <Icon src="PlusCircle" size={26} color={ADIColors.blue5} />
                                <Typography {...styles.addNewTitle}>
                                    {current === 0 ? "Add a New Account" : "Add a New Card"}
                                </Typography>
                            </AddButton>
                        </Hidden>
                    </TabSectionWrapper>

                    {current === 0 ? (
                        <BankAccountWrapper>
                            <BankAccountListInvoiceRecap
                                selectedBankId={selectedBankId}
                                bankAccountList={bankAccountList}
                                isLoading={isLoading}
                                handleRadioChange={handleRadioChange}
                                cartState={cartState}
                                showAddNewAccount={showAddNewAccount}
                                openAddNewAccount={openAddNewAccount}
                            />
                        </BankAccountWrapper>
                    ) : (
                        <BankAccountWrapper>
                            <CreditCardListInvoiceRecap
                                selectedCCId={selectedCCId}
                                callApi={callApi}
                                creditCardListRecap={creditCardListRecap}
                                isLoadingCreditCard={isLoadingCreditCard}
                                cartState={cartState}
                                showAddNewCard={showAddNewCard}
                                openAddNewCard={openAddNewCard}
                                handleCardRadioChange={handleCardRadioChange}
                                paymentTypes={paymentTypes}
                            />
                        </BankAccountWrapper>
                    )}
                    <Hidden above="sm">
                        <TabSectionWrapper>
                            <AddButton onClick={() => (current === 0 ? showAddNewAccount() : showAddNewCard())}>
                                <Icon src="PlusCircle" size={26} color={ADIColors.blue5} />
                                <Typography {...styles.addNewTitle}>
                                    {current === 0 ? "Add a New Account" : "Add a New Card"}
                                </Typography>
                            </AddButton>
                        </TabSectionWrapper>
                    </Hidden>
                    {
                        ((current == 0 && (bankAccountList !== undefined && bankAccountList.length > 0)) || (current != 0 && (creditCardListRecap !== undefined && creditCardListRecap.length > 0))) &&
                        (
                            <StyledWrapper {...styles.footerButtonWrapper}>
                                <Clickable href={invoicesLink}>
                                    <Button
                                        variant="secondary"
                                        {...styles.cancelButton}
                                        onClick={() => {
                                            dispatch({
                                                type: "Custom/UpdateRetrunToInvocie",
                                                result: true,
                                            });
                                        }}
                                    >
                                        {translate("Cancel")}
                                    </Button>
                                </Clickable>
                                <Button
                                    disabled={!selectedPaymentAccount || isPaymentInProgress || showAllowInvoicePayment === 'N'}
                                    variant="primary"
                                    onClick={payNowClickHandler}
                                    {...styles.button}
                                >
                                    {translate("Pay Now")}
                                </Button>
                            </StyledWrapper>
                        )
                    }
                </>
            )}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(ADIInvoiceRecapTab)),
    definition: {
        group: "My Account",
        displayName: "ADI Invoice Recap Tab",
    },
};

export default widgetModule;
